import { createApp } from "vue";
import BookingModal from "./components/BookingModal.vue";
import MessageThread from "./components/MessageThread.vue";
import { installBookingDiagnostics } from "./lib/bookingDiagnostics";

const headerApp = createApp({});
const bookingDiagnostics = installBookingDiagnostics({ app: headerApp });

headerApp.component("booking-modal", BookingModal);
headerApp.component("message-thread", MessageThread);
headerApp.provide("app", window.App);
headerApp.provide("bookingDiagnostics", bookingDiagnostics);
headerApp.mount("#vue-header-root");
